module.exports = __webpack_public_path__ + "img/7.335157c9.png";